import { ParentUsersUIProvider } from "./ParentUsersUIContext";
import { ParentUsersCard } from "./ParentUsersCard";

export function ParentUsersPage() {
  return (
    <ParentUsersUIProvider>
      <ParentUsersCard />
    </ParentUsersUIProvider>
 );
}